<template>
  <div>
    <div class="row q-ma-sm">
      <div class="col">
        <q-stepper
          v-model="step"
          ref="stepper"
          alternative-labels
          :contracted="$q.screen.lt.sm"
          color="primary"
          v-show="!this.hideInputs"
          class="q-mt-md xq-mb-md q-gutter-md"
          animated
          flat
        >
          <q-step :name="1" title="Register" icon="settings" :done="step > 1">
            <q-form
              v-show="!this.hideInputs"
              ref="registrationForm"
              class="q-mt-md xq-mb-md q-gutter-md"
              greedy
            >
              <div class="column justify-evenly">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class=" q-pb-md">
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="firstName"
                          type="text"
                          name="nameFirst"
                          id="nameFirst"
                          label="First Name *"
                          :rules="[val => !!val || 'First Name is required']"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="lastName"
                          type="text"
                          name="nameLast"
                          id="nameLast"
                          label="Last Name *"
                          :rules="[val => !!val || 'Last Name is required']"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="displayName"
                          type="text"
                          name="displayName"
                          id="displayName"
                          label="Display Name *"
                          :rules="[val => !!val || 'Display Name is required']"
                        />
                      </div>

                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="email"
                          type="text"
                          name="email"
                          id="email"
                          label="Email *"
                          :rules="[val => !!val || 'Email is required']"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="password"
                          type="password"
                          name="password"
                          id="password"
                          label="Password *"
                          :rules="[
                            val => !!val || 'Password is required',
                            val =>
                              val.length >= 6 ||
                              'Password should be at least 6 characters',
                          ]"
                          autocomplete="off"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="phoneNumber"
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          label="Phone Number"
                          mask="(###) ### - ####"
                          hint="(###) ### - ####"
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="birthDate"
                          type="text"
                          name="birthDate"
                          id="birthDate"
                          label="Birth Date"
                          mask="##/##/####"
                          hint="MM/DD/YYYY"
                          :rules="[val => true]"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class=" q-pb-md">
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="streetAddress"
                          type="text"
                          name="streetAddress"
                          id="streetAddress"
                          label="Address"
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="city"
                          type="text"
                          name="city"
                          id="city"
                          label="City"
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-select
                          clearable
                          filled
                          v-model="state"
                          option-value="abbreviation"
                          option-label="name"
                          :options="usStates"
                          label="State"
                          emit-value
                          map-options
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="zipCode"
                          type="text"
                          name="zipCode"
                          id="zipCode"
                          label="Zip Code"
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-select
                          clearable
                          filled
                          v-model="country"
                          option-value="code"
                          option-label="name"
                          :options="countries"
                          label="Country"
                          emit-value
                          map-options
                          :rules="[val => true]"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-select
                          clearable
                          filled
                          v-model="preferredCountry"
                          option-value="code"
                          option-label="nameFormatted"
                          :options="preferredCountries"
                          label="Preferred Country *"
                          emit-value
                          map-options
                          :rules="[
                            val => !!val || 'Preferred Country is required',
                          ]"
                          hint="The country you would like the map view to center on when the website loads"
                        />
                      </div>
                      <div class="q-pb-md q-pr-md">
                        <q-input
                          filled
                          v-model.trim="referralSource"
                          type="text"
                          name="referralSource"
                          id="referralSource"
                          label="Referral Source(s)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <p class="text-caption text-italic text-grey-8">
                Fields on the left (except phone number) are required.
              </p> -->
              <div>
                <a href="#" @click.stop="showFeatures = true"
                  >View Premium Features</a
                >
              </div>
              <q-field
                class="q-ml-sm"
                :value="acceptsAgreements"
                :rules="[val => !!val || 'Please accept the terms of use']"
                borderless
                dense
              >
                <q-checkbox v-model="acceptsAgreements"
                  >Yes, I understand and agree to the
                  <a href="#" @click.stop="showTermsOfUse = true"
                    >Open Links Terms of Service</a
                  >
                  and
                  <a href="#" @click.stop="showPrivacyDisclosures = true"
                    >Privacy Disclosures</a
                  >. *</q-checkbox
                >
              </q-field>
              <div class="q-ml-sm">
                <q-checkbox v-model="receiveEmails">
                  Receive occasional emails about Open Links product
                  enhancements, best practices and blogs</q-checkbox
                >
              </div>
              <div>
                * Required
              </div>
            </q-form>
            <q-dialog v-model="showFeatures">
              <q-card>
                <q-card-section>
                  <FeaturesTable></FeaturesTable>
                </q-card-section>
              </q-card>
            </q-dialog>
          </q-step>
          <q-step :name="2" title="Profile" icon="person" :done="step > 2">
            <q-form>
              <div class="q-pb-md">
                <q-input
                  filled
                  v-model.trim="homeCourse"
                  type="text"
                  name="homeCourse"
                  id="homeCourse"
                  label="Home Course(s)"
                  :rules="[val => !!val || 'This field is required']"
                />
              </div>
              <div class="q-pb-md">
                <q-select
                  clearable
                  filled
                  v-model="handicap"
                  :options="handicapRangeOptions"
                  label="Handicap?"
                  :rules="[val => !!val || 'This field is required']"
                />
              </div>
              <div class="q-pb-md">
                <q-select
                  clearable
                  filled
                  v-model="roundsPerYear"
                  :options="roundsPerYearOptions"
                  label="How many rounds do you play in a year?"
                  :rules="[val => !!val || 'This field is required']"
                />
              </div>
              <div class="q-pb-md">
                <q-select
                  clearable
                  filled
                  v-model="tripsPerYear"
                  :options="tripsPerYearOptions"
                  label="How many golf trips do you take per year?"
                  :rules="[val => !!val || 'This field is required']"
                />
              </div>
              <div class="q-pb-md">
                <q-select
                  clearable
                  filled
                  v-model="coursePreference"
                  :options="coursePreferenceOptions"
                  label="What do you value most in a golf course?"
                  :rules="[val => !!val || 'This field is required']"
                />
              </div>
            </q-form>
          </q-step>
          <template v-slot:navigation>
            <q-stepper-navigation>
              <q-btn
                v-if="step === 1"
                @click="checkRegistrationForm"
                :ripple="false"
                push
                color="primary"
                label="Continue"
              />
              <q-btn
                v-if="step === 2"
                @click="redirectToCheckout"
                :ripple="false"
                push
                color="primary"
                label="Register"
              />
              <q-btn
                v-if="step > 1"
                flat
                color="primary"
                @click="$refs.stepper.previous()"
                label="Back"
              />
            </q-stepper-navigation>
          </template>
        </q-stepper>
      </div>
    </div>
    <q-dialog v-model="showTermsOfUse">
      <q-card>
        <q-card-section>
          <div class="text-h6">Terms of Service</div>
        </q-card-section>

        <q-separator />

        <q-card-section style="max-height: 50vh" class="scroll">
          <TermsOfUse></TermsOfUse>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn
            label="Close"
            color="primary"
            v-close-popup
            @click="showTermsOfUse = false"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showPrivacyDisclosures">
      <q-card>
        <q-card-section>
          <div class="text-h6">Privacy Disclosures</div>
        </q-card-section>

        <q-separator />

        <q-card-section style="max-height: 50vh" class="scroll">
          <PrivacyDisclosures></PrivacyDisclosures>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn
            label="Close"
            color="primary"
            v-close-popup
            @click="showPrivacyDisclosures = false"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TermsOfUse from "@/components/TermsOfUse.vue";
import PrivacyDisclosures from "@/components/PrivacyDisclosures.vue";
import FeaturesTable from "@/components/FeaturesTable";
import US_STATES from "@/data/us-states.json";
import COUNTRIES from "@/data/countries.json";
import { dedupe } from "@/utils";

const COUNTRIES_FORMATTED = Object.freeze(
  COUNTRIES.map(c => {
    const nameFormatted = `${c.name} (${c.code})`;

    return {
      ...c,
      nameFormatted,
    };
  }),
);

export default {
  name: "Register",
  components: {
    TermsOfUse,
    FeaturesTable,
    PrivacyDisclosures,
  },
  data() {
    return {
      receiveEmails: true,
      showTermsOfUse: false,
      showPrivacyDisclosures: false,
      acceptsAgreements: false,
      showFeatures: false,
      hideInputs: false,
      firstName: "",
      lastName: "",
      displayName: "",
      phoneNumber: "",
      streetAddress: "",
      zipCode: "",
      city: "",
      birthDate: "",
      state: null,
      country: "US",
      preferredCountry: "US",
      email: "",
      password: "",
      addUserSuccess: false,
      addUserError: false,
      sendEmailSuccess: false,
      sendEmailError: false,
      step: 1,
      handicap: null,
      roundsPerYear: null,
      tripsPerYear: null,
      homeCourse: "",
      coursePreference: null,
      coursePreferenceOptions: [
        "Design",
        "Conditions",
        "Amenities/Experience",
        "History",
      ],
      roundsPerYearOptions: ["0-10", "11-25", "26-50", "50-99", "100+"],
      tripsPerYearOptions: ["0", "1-2", "3-5", "6-10", "11+"],
      handicapRangeOptions: ["Plus", "0-9", "10-19", "20+"],
      referralSource: "",
      usStates: US_STATES,
      countries: COUNTRIES,
    };
  },
  mounted() {
    this.$session.remove("registrationInfo");
  },
  computed: {
    ...mapGetters(["courses"]),
    successMessage() {
      return this.successMessages.join(" ");
    },
    errorMessage() {
      return this.errorMessages.join(" ");
    },
    registrationInfo() {
      const user = {
        receiveEmails: this.receiveEmails,
        firstName: this.firstName,
        lastName: this.lastName,
        displayName: this.displayName,
        phoneNumber: this.phoneNumber,
        streetAddress: this.streetAddress,
        zipCode: this.zipCode,
        city: this.city,
        birthDate: this.birthDate,
        state: this.state,
        country: this.country,
        preferredCountry: this.preferredCountry,
        email: this.email,
        password: this.password,
        handicap: this.handicap,
        roundsPerYear: this.roundsPerYear,
        tripsPerYear: this.tripsPerYear,
        homeCourse: this.homeCourse,
        coursePreference: this.coursePreference,
        referralSource: this.referralSource,
      };

      return JSON.stringify(user);
    },
    courseCountries() {
      const courses = this.courses;
      const allItems = courses.map(course => course.OLGDP101);
      const deDupedItems = dedupe(allItems);

      deDupedItems.sort();

      return deDupedItems;
    },
    preferredCountries() {
      return COUNTRIES_FORMATTED.filter(c =>
        this.courseCountries.includes(c.name),
      );
    },
  },
  methods: {
    acceptTermsOfUse() {
      this.acceptsTermsOfUse = true;
    },
    declineTermsOfUse() {
      this.acceptsTermsOfUse = false;
    },
    acceptPrivacyDisclosures() {
      this.acceptsPrivacyDisclosures = true;
    },
    declinePrivacyDisclosures() {
      this.acceptsPrivacyDisclosures = false;
    },
    checkRegistrationForm() {
      if (this.$refs.registrationForm) {
        this.$refs.registrationForm.validate().then(success => {
          if (success) {
            this.$refs.stepper.next();
          } else {
            return;
          }
        });
      }
    },
    redirectToCheckout() {
      this.$session.set("registrationInfo", this.registrationInfo);
      this.$router.push("/register-success");
    },
    toggleAgreements() {
      this.acceptsTermsOfUse = !this.acceptsTermsOfUse;
      this.acceptsPrivacyDisclosures = !this.acceptsPrivacyDisclosures;
    },
  },
};
</script>
